export enum DashboardTabsKeysEnum {
  overviewBTC = 'overview_BTC',
  overviewETH = 'overview_ETH',
  overviewSOL = 'overview_SOL',
  overviewMATIC = 'overview_MATIC',
  overviewXRP = 'overview_XRP',
  overviewBNB = 'overview_BNB',
  overviewPAXG = 'overview_PAXG',
  compare = 'compare',
  volLab = 'vol_lab',
  altSurfaceBuilder = 'alt_surface_builder',
  marketChange = 'market_change',
}
